import React, { createContext, useContext, useState, useEffect } from 'react'
import { getAnswerByQuestion } from '../../../../../../../utils/question.helper'
import { useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../../store/selectors/text-submission-drawer.selectors'

const AnswerContext = createContext({})

export const AnswerContextProvider = ({ children, answers, question }) => {
    const focusedQuestionId = useSelector(textSubmissionDrawerSelectors.focusedQuestionId)
    const answer = getAnswerByQuestion(answers, question, focusedQuestionId)
    const [categoryIdToHighlight, setCategoryIdToHighlight] = useState(answer?.categoryId)

    // Update categoryIdToHighlight when focusedQuestionId or answer changes
    useEffect(() => {
        setCategoryIdToHighlight(answer?.categoryId)
    }, [focusedQuestionId, answer?.categoryId])

    return (
        <AnswerContext.Provider value={{ categoryIdToHighlight, setCategoryIdToHighlight }}>
            {children}
        </AnswerContext.Provider>
    )
}

export const useAnswerContext = () => useContext(AnswerContext)
